import { useNavigate, useParams } from "react-router-dom";
import { useState } from "react";
import { loginAsUser } from "../../../utils/Admin";
import PasswordResetModal from "../../../Components/Modals/PasswordResetModal";
import EnableDisableButton from "../../../utils/EnableDisableButton";

export default function ActionTab() {
  const { parentId } = useParams();
  const [showResetModal, setShowResetModal] = useState(false);
  const [selecteduserId, setSelectedUserId] = useState(null);
  const navigate = useNavigate();

  // Open modal for password reset
  const handleSetPasswordClick = (parentId) => {
    setSelectedUserId(parentId);
    setShowResetModal(true);
  };
  return (
    <>
      <button
        className="text-white px-5 py-1 bg-lime-600 rounded-lg border justify-center ml-4"
        onClick={() => loginAsUser(parentId)}
      >
        Login As Parent
      </button>

      <button
        className="text-white px-5 py-1 bg-lime-600 rounded-lg border justify-center ml-4"
        onClick={() => handleSetPasswordClick(parentId)}
      >
        Reset Password
      </button>

      <EnableDisableButton userId={parentId} redirect={'/parent'}/>

      {showResetModal && (
        <PasswordResetModal
          userId={selecteduserId}
          onClose={() => setShowResetModal(false)}
          redirect={() => navigate("/parent")}
        />
      )}
    </>
  );
}
